import * as React from "react";
import {Typography, withStyles} from "@material-ui/core";
import {CheckboxStyle} from "@components/common/checkbox/checkbox.style";

interface ICheckboxProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: React.ReactNode;
    classes: any;
    error?: string | undefined;
    labelStyle?: React.CSSProperties;
}

interface ICheckboxState {
    isFocused: boolean;
}

class Checkbox extends React.Component<ICheckboxProps, ICheckboxState> {
    private checkboxRef: React.RefObject<HTMLInputElement>;

    constructor(props: ICheckboxProps) {
        super(props);
        this.checkboxRef = React.createRef();

        this.state = {
            isFocused: false,
        };

        this.handleCheckboxBlur = this.handleCheckboxBlur.bind(this);
        this.handleCheckboxFocus = this.handleCheckboxFocus.bind(this);
    }

    public render() {
        const {isFocused} = this.state;
        const {label, labelStyle, classes, error, ...rest} = this.props;
        const checkboxClassName = error ? classes.invalidCheckbox : (isFocused ? classes.focusedCheckbox : '');
        const labelClassName = error ? classes.invalidLabel : classes.validLabel;

        return (<div className={classes.root}>
            <label className={classes.label} style={labelStyle}>
                <input
                    {...rest}
                    ref={this.checkboxRef}
                    id={rest.id}
                    className={`${classes.checkbox} ${checkboxClassName}`}
                    type="checkbox"
                    onBlur={this.handleCheckboxBlur}
                    onFocus={this.handleCheckboxFocus}
                />

                    <Typography className={`${labelClassName}`}>{label}</Typography>
            </label>
            {error && <span className={classes.errorMessage}>{error}</span>}
        </div>);
    }

    private handleCheckboxBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: false,
        });
        const checkboxElement = this.checkboxRef.current;
        if (checkboxElement) {
            checkboxElement.reportValidity(); // Trigger HTML checkbox validity check
        }

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    private handleCheckboxFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }
}

export default withStyles(CheckboxStyle)(Checkbox);



// WEBPACK FOOTER //
// ./src/components/common/checkbox/checkbox.component.tsx